<template>
  <o-view>
    <o-view>
      <o-nav-bar title="Discount Rights" :has-back-button="true" />
      <o-block-list>
        <o-section>
          <o-checkbox>Preferential Reimbursement</o-checkbox>
        </o-section>
        <o-section> <o-checkbox>Large Family</o-checkbox> </o-section>
        <o-section> <o-checkbox>Military</o-checkbox> </o-section>
      </o-block-list>
    </o-view>
    <o-pay-button label="Save" @click="goBack" />
  </o-view>
</template>

<script>
import OPayButton from '@/components/OPayButton.vue'
export default {
  components: {
    OPayButton
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
